import React, { useEffect, useRef, useState } from "react";
import Header from "../../../Components/adminDashboard/Header/Header";
import "../PaymentGateway/PaymentGateway.scss";
import "./Audio.scss";
import combinedServices from "../../../shared/services/user-service";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import { Spinner } from "reactstrap";
import swal from "sweetalert";

function Audios() {
  const [uploadAudioUrl, setUploadAudioUrl] = useState("");
  const [audios, setAudios] = useState([]);
  const [deleted, setDeleted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [duration, setDuration] = useState("");
  const [isError, setIsError] = useState(false);
  const [audioName, setAudioName] = useState("");
  const fileInputRef = useRef(null);

  useEffect(() => {
    getAllAudios();
  }, [deleted]);

  const getAllAudios = async () => {
    let response = await combinedServices.getAudios();
    setAudios(response.data);
  };

  const handleUploadAudio = (e) => {
    if (e.target.files && e.target.files[0]) {
      let audioFile = e.target.files[0];
      const objectUrl = URL.createObjectURL(audioFile);
      const audio = new Audio(objectUrl);
      audio.onloadedmetadata = () => {
        const minutes = Math.floor(audio.duration / 60);
        const seconds = Math.floor(audio.duration % 60)
          .toString()
          .padStart(2, "0");
        const durationStr = `${minutes}:${seconds}`;
        setDuration(durationStr);
        const formData = new FormData();
        formData.append("image", audioFile);
        setUploadAudioUrl(formData);

        promptForAudioName();
      };
    }
  };

  const promptForAudioName = async () => {
    const existingNames = audios.map((audio) =>
      audio.name?.trim().toLowerCase()
    );

    let validName = null;
    while (!validName) {
      const name = await swal({
        title: "Enter Audio Name",
        content: "input",
        button: {
          text: "Submit",
          closeModal: true,
        },
      });

      if (!name) {
        swal("Error", "Audio name is required!", "error");
        return;
      }

      if (existingNames.includes(name.trim().toLowerCase())) {
        await swal("Error", "Audio name already exists. Try another.", "error");
      } else {
        validName = name.trim();
      }
    }

    setAudioName(validName);
  };

  const handleUploadToBucket = async () => {
    if (uploadAudioUrl && duration && audioName) {
      uploadAudioToBucket(uploadAudioUrl, duration, audioName);
    } else {
      setIsError(true);
      swal("Error", "Please select an audio and enter a name!", "error");
    }
  };

  const uploadAudioToBucket = async (fileData, audioDuration, name) => {
    setIsLoading(true);
    let response = await combinedServices.uploadImage(fileData);

    if (response.status === 200) {
      const data = {
        audio_url: response.data.location,
        status: "inactive",
        audio_len: audioDuration,
        audio_class: "electric",
        name: name,
      };

      const added = await combinedServices.addAudio(data);

      if (added.status === 200) {
        setIsLoading(false);
        getAllAudios();
        setIsError(false);
        swal("Success", "Audio uploaded successfully!", "success");
        setAudioName("");
        setUploadAudioUrl("")
        if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      } else {
        setIsLoading(false);
        swal("Error", "Failed to add audio. Try again.", "error");
      }
    } else {
      setIsLoading(false);
      swal("Error", "Failed to upload audio. Try again.", "error");
    }
  };

  const handleDeleteAudio = async (e, id) => {
    e.stopPropagation();
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this audio!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        const data = { id: id };
        const response = await combinedServices.deleteAudio(data);
        if (response.status === 200) {
          getAllAudios();
          swal("Deleted!", "Your audio has been deleted!", "success");
        }
      }
    });
  };

  const handleUpdateStatus = async (e, id) => {
    const data = {
      status: e.target.checked ? "active" : "inactive",
      id: id,
    };
    await combinedServices.updateAudioStatus(data);
    getAllAudios();
  };

  const buttonStyle = {
    width: "fit-content",
    color: "white",
    fontSize: "12px",
    borderRadius: "3px",
    backgroundColor: "#01458b",
    padding: "5px",
    alignItems: "center",
    border: "none",
  };

  return (
    <>
      <Header />
      <div className="dbAdminRight">
        <div className="dbMid dbInner">
          <div className="flexBox spacebetween topHdBox">
            <h3>Audio</h3>
          </div>
          <div className="flexBox spacebetween">
            <div className="pgBox whtBox">
              <div>
                <input
                  type="file"
                  name="imageUpload"
                  onChange={handleUploadAudio}
                  ref={fileInputRef}
                />
                {!isLoading ? (
                  <button onClick={handleUploadToBucket} style={buttonStyle}>
                    Upload
                  </button>
                ) : (
                  <div className="text-center mt-4 loadMore">
                    <Spinner color="primary" />
                  </div>
                )}
                {isError && (
                  <p style={{ color: "red" }}>Select Audio and Enter Name</p>
                )}
              </div>

              <table
                style={{
                  borderCollapse: "collapse",
                  width: "100%",
                  marginTop: "20px",
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "lightgray", height: "40px" }}>
                    <th style={{ textAlign: "center", fontWeight: "400", padding: "10px" }}></th>
                    <th style={{ textAlign: "center", fontWeight: "400", padding: "10px" }}>
                      Audio
                    </th>
                    <th style={{ textAlign: "left", fontWeight: "400" }}>
                      Name
                    </th>
                    <th style={{ textAlign: "left", fontWeight: "400" }}>
                      Duration
                    </th>
                    <th style={{ textAlign: "left", fontWeight: "400" }}>
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {audios?.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="checkbox"
                          style={{ height: "20px", width: "20px" }}
                          checked={item.status === "active"}
                          onChange={(e) => handleUpdateStatus(e, item.id)}
                        />
                      </td>
                      <td
                        style={{
                          display: "flex",
                          justifyContent: "space-evenly",
                          margin: "10px 0",
                        }}
                      >
                        <audio controls>
                          <source src={item.audio_url} type="audio/mpeg" />
                        </audio>
                        <IconButton aria-label="delete">
                          <DeleteIcon
                            onClick={(e) => handleDeleteAudio(e, item.id)}
                          />
                        </IconButton>
                      </td>
                      <td>
                        <span>{item.name || ""}</span>
                      </td>
                      <td>
                        <span>{item.audio_len}</span>
                      </td>
                      <td>
                        <span>{item.status}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Audios;
